import { CountryCodeEnum } from 'features/common/types';

export interface WhatsAppBannerConfig {
	countryCode: CountryCodeEnum;
	url: string;
}

export const whatsappBannerUrls: WhatsAppBannerConfig[] = [
	{
		countryCode: CountryCodeEnum.URUGUAY,
		url: 'https://whatsapp.com/channel/0029Vb7MuYh2ER6otu2Cdd3O',
	},
	{
		countryCode: CountryCodeEnum.PARAGUAY,
		url: 'https://whatsapp.com/channel/0029Vb7dmHn4o7qFFwaS6V0q',
	},
	// {
	// 	countryCode: CountryCodeEnum.COLOMBIA,
	// 	url: 'https://wa.me/57XXXXXXXXX', // Reemplazar con la URL real de WhatsApp para Colombia
	// },
	// {
	// 	countryCode: CountryCodeEnum.BOLIVIA,
	// 	url: 'https://wa.me/591XXXXXXXXX', // Reemplazar con la URL real de WhatsApp para Bolivia
	// },
	// {
	// 	countryCode: CountryCodeEnum.TN_ITAU_PY,
	// 	url: 'https://wa.me/595XXXXXXXXX', // Reemplazar con la URL real de WhatsApp para TN Itaú Paraguay
	// },
];

/**
 * Obtiene la URL de WhatsApp para un país específico
 */
export const getWhatsAppUrl = (countryCode: CountryCodeEnum): string | null => {
	const config = whatsappBannerUrls.find((item) => item.countryCode === countryCode);
	return config?.url || null;
};
